
import  { useState, useEffect } from "react";
import { Avatar, Flex, Layout,  Popover, theme, Breadcrumb, Button } from "antd";
import {  ArrowLeftOutlined, BackwardOutlined, UserOutlined } from '@ant-design/icons';
import logo from '../../images/nexaid_logo_bgless.png';
import styled from "styled-components";
import AvatarMenu from "./userMenu";
import MasterMenu from "./masterMenu";
import { Navigate, Outlet, useMatches } from "react-router";
import { NavLink, redirect, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getConsts } from "./homeThunk";
import { selectToken, selectUsername } from "./homeSlice";
import RoutePath from "../../app/routing/routes.path";
import Link from "antd/es/typography/Link";

const { Header, Footer, Content } = Layout;



const HeaderLogo = styled.img`
    height: 64px;
    padding: 10px;
`;

const HeaderText = styled.div`
    color: white;
    font-size: 24px;
    font-weight: bold;
    margin-right: 10px;
`

const UserAvatar = styled.div`
    margin: 0 24px;
`

const MasterMenuContainer = styled.div`
    flex-grow: 1;
`

const BreadcrumbWrapper = styled.div`
    padding: 10px 24px;
`
const BackArrow = styled(ArrowLeftOutlined)`
    padding: 15;
`


export default function Home() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [avatarMenuOpen, setAvtarMenu] = useState(false);
    const BackButton = <BackArrow onClick={()=>navigate(-1)}/>;
    const [breadcrumbItems, setBreadcrumbItems] = useState([{
        title: BackButton
    }]);

    let match = useMatches();
    useEffect(() => {
        let item:any = match.filter(m => {
            let x: any = m.handle;
            return !!x && !!x.crumb;
        }).map(m => {
                let x: any = m.handle;
                let crumb = x.crumb;
                if (typeof crumb == 'function' ){
                    crumb = crumb(m);
                }
                return {title: (<NavLink to = { m.pathname }> { crumb }</NavLink >)}
        });
        setBreadcrumbItems([{title: BackButton}, ...item]);
    }, [match]);

    useEffect(() => {
        dispatch(getConsts());
    }, []);

    ///****** Validate Login **********/
    const username = localStorage.getItem('username');
    const token = localStorage.getItem('token');
    if (!username || !token) {
        return <Navigate to="/login" replace />;
    }
    ///////////////////////////////////

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    return (<Layout style={{ height: '100%' }}>
        {/* <Sider
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {
                // console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
                // console.log(collapsed, type);
            }}
        >
            
            <Menu theme="dark" mode="inline" defaultSelectedKeys={['4']} items={items} />
        </Sider> */}
        <Layout>
            <Header style={{ padding: 0 }} >
                <Flex justify="space-between">
                    <Flex justify="center" align="center">
                        <HeaderLogo src={logo} />
                        <HeaderText>NEXAID</HeaderText>
                    </Flex>
                    <MasterMenuContainer>
                        <MasterMenu ></MasterMenu>
                    </MasterMenuContainer>
                    <UserAvatar>
                        <Popover
                            content={<AvatarMenu />}
                            title={username}
                            trigger="click"
                            open={avatarMenuOpen}
                            onOpenChange={() => { setAvtarMenu(!avatarMenuOpen) }}
                        >
                            <Avatar style={{ backgroundColor: '#fde3cf', color: '#f56a00', cursor: 'pointer' }}>
                                {username[0].toUpperCase()}
                            </Avatar>
                        </Popover>
                    </UserAvatar>
                </Flex>
                
            </Header>
            <BreadcrumbWrapper><Breadcrumb items={breadcrumbItems}/></BreadcrumbWrapper>
            <Content style={{ margin: 10, marginBottom: 20 }}>
                <div
                    style={{
                        padding: 5,
                        height: '100%',
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                        overflow: 'auto',
                        // maxWidth: '1200px',
                        // margin: 'auto'
                    }}
                >
                    <Outlet />
                </div>
            </Content>
            {/* Hide Footer on mobile screens */}
            <Footer
                style={{
                    textAlign: 'center',
                    display: 'none',
                }}
                className="footer-desktop"
            >
                Artificial Intelligent Next-gen Analytics (<b>AINA</b>) © {new Date().getFullYear()} Powered by: Nexaid Technologies
            </Footer>
            <style>
            {`
                @media (min-width: 768px) {
                    .footer-desktop {
                        display: block !important;
                    }
                }
            `}
            </style>
        </Layout>
    </Layout>)
}

